import React, { useEffect, useRef } from 'react';
/**
 * ScrollIntoView
 * Component to make sure the children could scroll into view
 * @public
 */
export const ScrollIntoView = props => {
  const myRef = useRef(null);
  useEffect(() => {
    if (!!myRef && !!myRef.current) {
      const refDOM = myRef.current;
      if (refDOM === null || refDOM === void 0 ? void 0 : refDOM.scrollIntoView) {
        refDOM === null || refDOM === void 0 ? void 0 : refDOM.scrollIntoView({
          behavior: 'smooth',
          inline: 'nearest'
        });
      }
    }
  }, []);
  return React.createElement("div", {
    ref: myRef,
    style: Object.assign({}, props.style)
  }, props.children);
};